import {
  PROMO_CODES_LOADING,
  PROMO_CODES_ERROR,

  PROMO_CODES_LIST,
  PROMO_CODES_CREATE,
  // PROMO_CODES_UPDATE,
  PROMO_CODES_DELETE,
  PROMO_CODES_FILTERS, PROMO_CODES_STATUSES, PROMO_CODES_SEARCH,
} from "actions/promo-codes/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  search: {
    content: [],
  },
  filters: [],
  statuses: []
};

export default function (state = initialState, action) {
  let list = [],
    index;
  switch (action.type) {
    case PROMO_CODES_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case PROMO_CODES_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case PROMO_CODES_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        list: action.payload.content,
      };
    case PROMO_CODES_SEARCH:
      return {
        ...state,
        errors: [],
        loading: false,
        search: action.payload,
      };
    case PROMO_CODES_CREATE:
      list = Object.assign([], state.list);
      if (action.payload.create) {
        list.push(action.payload.data);
      } else {
        index = list.findIndex(item => item.id === action.payload.data.id);
        if (index > -1) {
          list[index] = action.payload.data;
        }
      }

      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    case PROMO_CODES_DELETE:
      list = Object.assign([], state.list);
      index = list.findIndex(item => item.id === action.payload);
      if (index > -1) {
        list.splice(index, 1);
      }
      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    case PROMO_CODES_FILTERS:
      return {
        ...state,
        loading: false,
        filters: action.payload.content
      };
    case PROMO_CODES_STATUSES:
      return {
        ...state,
        errors: [],
        loading: false,
        statuses: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/promoCodesReducer.js